import type { Identifier } from "ra-core";

import { getSupabaseClient } from "../providers/supabase/supabase";

export const CLIENT_FILES_BUCKET = "client-files";
export const MAX_CLIENT_FILE_BYTES = 50 * 1024 * 1024;

export const isImagePath = (path: string): boolean =>
  /\.(png|jpe?g|webp|gif|avif|svg)$/i.test(path);

/** Uploads to <companyId>/<folder>/<timestamp>-<name> and returns the storage path. */
export const uploadClientFile = async (
  companyId: Identifier,
  folder: "reports" | "brand",
  file: File,
): Promise<string> => {
  const safeName = file.name.replace(/[^\w.-]+/g, "_");
  const path = `${companyId}/${folder}/${Date.now()}-${safeName}`;
  const { error } = await getSupabaseClient()
    .storage.from(CLIENT_FILES_BUCKET)
    .upload(path, file, { contentType: file.type });
  if (error) throw error;
  return path;
};

export const removeClientFile = async (path: string): Promise<void> => {
  await getSupabaseClient().storage.from(CLIENT_FILES_BUCKET).remove([path]);
};
